import { createFileRoute, Link } from '@tanstack/react-router'
import { Section, SectionHeader } from '@/components/ui/section'
import { Button } from '@/components/ui/button'
import { TrendingUp, Shield } from 'lucide-react'

export const Route = createFileRoute('/about')({
  component: AboutComponent,
})

function AboutComponent() {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="gradient-hero py-20">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              About <span className="text-gradient">AIAlgo.trading</span>
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              We are democratizing access to institutional-grade algorithmic trading tools for the futures market.
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <Section>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <SectionHeader
              align="left"
              title="Our Mission"
              description="To bridge the gap between retail traders and institutional technology."
              titleClassName="text-3xl"
              descriptionClassName="mx-0"
            />
            <div className="space-y-4 text-muted-foreground">
              <p>
                Founded in 2025, AIAlgo.trading was built on the belief that the future of trading is automated, data-driven, and accessible.
              </p>
              <p>
                We combine cutting-edge AI, robust backtesting engines, and a verified marketplace to provide recent and experienced traders with the edge they need in the fast-paced futures market.
              </p>
            </div>
            <div className="mt-8">
              <Link to="/marketplace">
                <Button size="lg">Explore the Marketplace</Button>
              </Link>
            </div>
          </div>
          <div className="grid gap-6">
            <div className="card p-6">
              <TrendingUp className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">Performance First</h3>
              <p className="text-muted-foreground">Every algorithm on our platform is rigorously backtested and verified.</p>
            </div>
            <div className="card p-6">
              <Shield className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">Trust & Security</h3>
              <p className="text-muted-foreground">Enterprise-grade security and transparent performance tracking.</p>
            </div>
          </div>
        </div>
      </Section>

      {/* Team (Placeholder) */}
      <Section variant="muted">
        <SectionHeader
          title="Built by Traders, for Traders"
          description="Our team brings together expertise from quantitative finance, AI research, and software engineering."
        />
        {/* Add team members here later */}
      </Section>
    </div>
  )
}
